import React, { useCallback } from 'react';
import './UpdateRuleDataTriggerEditor.less';
import { IEditorProps } from './Editor';
import { getEditorConfigValue } from 'components/property-editors/utils/EditorConfigurationUtils';
import { EditorConfigButtons } from './EditorConfigButtons';
import { EditorConfigButton } from './EditorConfigButton';
import { EditorLabel } from './EditorLabel';

export interface IUpdateRuleDataTriggerEditorProps extends IEditorProps {}

/**
 * An editor that appears as a button for updating flow inputs.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function UpdateRuleDataTriggerEditor({ child, path, id, onChange }: IUpdateRuleDataTriggerEditorProps) {
  const linkName = getEditorConfigValue(child, 'linkName') || 'Update Inputs';

  const onClickHandler = useCallback(() => {
    // any random number will be fine, just used to update the inputs/outputs
    onChange(42, path);
  }, [onChange, path]);

  return (
    <EditorLabel htmlFor={id} editor={child} path={path} doNotWrap hideInputLabel={true}>
      <div className="dpc-update-rule-data-trigger-editor">
        <EditorConfigButtons className="dpc-update-rule-data-trigger-editor__buttons">
          <EditorConfigButton className="dpc-update-rule-data-trigger-editor__button" onClick={onClickHandler}>
            {linkName}
          </EditorConfigButton>
        </EditorConfigButtons>
      </div>
    </EditorLabel>
  );
}
